<template>
  <div class="app-progress-bar progress">
    <div class="progress-bar progress-bar-striped progress-bar-custom active" role="progressbar"
         aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" :style="progressStyle">
      <span class="sr-only">45% Complete</span>
    </div>
  </div>
</template>

<script>
  import {EVENT_SET_PROGRESS} from '@/constants';

  export default {
    name: "ProgressBar",
    data() {
      return {
        progressStyle: {
          width: '0',
        },
      }
    },
    mounted() {
      this.$root.$on(EVENT_SET_PROGRESS, this.setProgress);
    },
    methods: {
      setProgress(progress) {
        if (progress.active) {
          this.progressStyle.width = `${progress.value}%`;
        } else {
          this.progressStyle.width = `0%`;
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .app-progress-bar {
    position: fixed;
    width: 100%;
    height: 5px;
    top: 0;
    left: 0;
    z-index: 10;

    .progress-bar-custom {
      background-color: #10b894;
    }
  }
</style>